var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-lg-none"},[_c('i',{staticClass:"fa fa-bars fa-lg toggle",on:{"click":_vm.toggleSidebar}})])}
var staticRenderFns = []

export { render, staticRenderFns }